import { render } from "./BodyComponentReportView.vue?vue&type=template&id=e093b006&scoped=true"
import script from "./BodyComponentReportView.vue?vue&type=script&lang=js"
export * from "./BodyComponentReportView.vue?vue&type=script&lang=js"

import "./BodyComponentReportView.vue?vue&type=style&index=0&id=e093b006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e093b006"]])

export default __exports__